import { authHeader, BASE_URL, handleResponse } from '@helpers/api';

function get() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/pulse-ai/agents`, requestOptions).then(handleResponse);
}

function deleteAgent(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/pulse-ai/agents/${id}`, requestOptions).then(handleResponse);
}

function createOrUpdateAgent(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/pulse-ai/agents`, requestOptions).then(handleResponse);
}

function updateStatusAgent(id, isActive) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/pulse-ai/agents/${id}:${isActive ? 'disable' : 'activate'}`, requestOptions).then(
        handleResponse,
    );
}

function sendPlaygroundMessage(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/pulse-ai/playground/messages`, requestOptions).then(handleResponse);
}

export const agentsService = {
    get,
    deleteAgent,
    createOrUpdateAgent,
    updateStatusAgent,
    sendPlaygroundMessage,
};
